import styled from 'styled-components';

import Content from 'ggApp/shared/components/Cart/CartOverlay';

const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    max-height: 80vh;
    background: ${({ theme }) => theme.colors.ElementBackground};
    box-shadow: 0px 7px 15px rgba(0, 0, 0, 0.13), 0px 0px 3px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        display: none;
    `}
    overflow-x: hidden;
`;

const CartContent = styled(Content)`
    min-height: 342px;
    width: 412px;
    justify-content: space-between;
`;

export { Wrap, CartContent };
